export default __webpack_public_path__ + "0c69e72dbc9c5fb7be15980206a30df5.png";